export default __webpack_public_path__ + "2bc6c2327bc256415b78cb981fae0002.mp3";